import { addonList } from '@api/sdk.gen';

// Last resort when the list is empty or unavailable: a page explaining that
// the user's team has no accessible add-on, instead of guessing a dead path.
// Needs hashbang because AngularJS does not handle the route change
const NO_ADDON_ACCESS_PATH = '/#!/no-addon-access';

/**
 * Where to send a user whose team denies Portainer access. The add-on list is
 * already scoped to what the user can reach, so the target follows from access.
 *
 * This is the fallback, not the memory: a user returning to the add-on they were
 * last in arrives by returnUrl, which login consumes before reaching here.
 */
export async function resolveLandingAddonPath() {
  try {
    // view=switcher is the launchable set: installed, enabled, carrying a path,
    // and accessible to the caller. The unfiltered list can name a catalog entry
    // an admin is able to see but not open.
    const { data } = await addonList({ query: { view: 'switcher' } });
    const addons = data?.addons ?? [];

    return addons[0]?.path || NO_ADDON_ACCESS_PATH;
  } catch {
    return NO_ADDON_ACCESS_PATH;
  }
}
